export default "__VITE_ASSET__571842fd__"